import { DropdownSettings } from '@/pages/roster/staffPicker/rosterPickerHelper';
import { FC } from 'react';
import { DropdownOption, GridDropdownType, GridSelect, GridSelectTabs } from '../grid/GridSelect';
import { InputProps, withField } from './withField';

interface GridSelectInputProps {
  itemsPerRow: number;
  dropdownOptions?: DropdownOption[];
  dropdownId?: string;
  parentContainerId?: string;
  showDefaultEmptyOption?: boolean;
  dropdownSettings?: DropdownSettings;
  type: GridDropdownType;
  tabs?: GridSelectTabs;
  children?: React.ReactNode;
}

const GridSelectInput: FC<InputProps<string> & GridSelectInputProps> = ({
  value,
  onChange,
  readOnly,
  className,
  ...props
}) => <GridSelect {...props} className={className ?? ''} selectedId={value} readOnly={readOnly} onChange={onChange} />;

export const GridSelectField = withField<string, GridSelectInputProps>(GridSelectInput);
